import styled from "styled-components";

const MobileNewSidebar = styled.div`
  background: ${(props) => props.theme.colordwhitedark};
  width: 100%;
  @media (min-width: 0px) and (max-width: 820px) {
    display: flex;
  }
  .ant-tabs {
    width: 100%;
    .ant-tabs-nav {
      position: fixed;
      left: 0;
      right: 0;
      top: 64px;
      z-index: 9;
      background: ${(props) => props.theme.colordwhitedark};
      margin-bottom: 0;
      &:before {
        border-color: ${(props) => props.theme.colorbluegreylight};
      }
    }
    .ant-tabs-nav-wrap {
      overflow-x: auto;
    }
    .ant-tabs-nav-list {
      width: 100%;
      .ant-tabs-tab {
        flex: 0 0 50%;
        max-width: 50%;
        justify-content: center;
        margin: 0;
        .ant-tabs-tab-btn {
          font-size: 14px;
          pointer-events: none;
        }
      }
    }
  }
`;
export default MobileNewSidebar;
